import * as httpApi from '@cian/http-api/browser';
import * as telemetry from '@cian/telemetry/browser';

export function setupDependencies() {
  telemetry.setup();
  httpApi.setup({});
}
